module.exports = __webpack_public_path__ + "img/yxsl.7daf2df8.png";